<form class="theme-primary height-full" #webexImportForm="ngForm" name="webexImportForm" (submit)="import()">

	<div class="modal-header" [ngClass]="styles.dialogHeader">
		<div [ngClass]="styles.headerTitle">
			<h1 class="util-break-word" id="modal-title">
				{{ (showWebexSiteSelection ? 'Uploads_Import_WebEx_SiteSelection_Header' : 'Uploads_Import_WebEx') | translate }}
			</h1>
		</div>
		<div [ngClass]="styles.headerClose">
			<button type="button" class="btn float-right btn-transparent" [attr.aria-label]="'Close' | translate" (click)="closeDialog()">
				<span class="glyphicons remove_2"></span>
			</button>
		</div>
	</div>

	<div class="modal-body" [ngClass]="styles.dialogBodyWrapper">
		<div [ngClass]="[styles.dialogBody, showWebexSiteSelection ? styles.halfWidth : '']">
			@if (showWebexSiteSelection) {
				<label class="padding-bottom-10" for="uiSelectSite">{{ 'Uploads_Import_WebEx_SiteSelection_Notes' | translate }}</label>
				<select name="uiSelectSite" class="form-select" [(ngModel)]="selectedSite" [required]="true">
					<option [ngValue]="null">{{ 'Uploads_Import_WebEx_SiteSelection' | translate }}</option>
					@for (site of webexSitesSettings; track site) {
						<option [ngValue]="site">{{ site.name }} ({{ site.url }})</option>
					}
				</select>
			} @else {
				@if (isLoading) {
					<vb-loading-overlay [loadingMessage]="'Loading' | translate"></vb-loading-overlay>
				}
				@if (webexRecordings?.length ) {
					<div class="padding-top-10 padding-bottom-10">
						<span class="type-bold">{{ 'Uploads_Import_SelectVideos' | translate }}</span>
						<span class="type-bold type-14 padding-left-5">({{ 'Media_NumVideos' | translate : { '0' : webexRecordings?.length } }})</span>
						@if (this.getSelectedImports()?.length) {
							<span class="type-bold type-14 padding-left-5">({{ 'Media_BulkEdit_SelectionCount' | translate : { '0': this.getSelectedImports()?.length | number } }})</span>
						}
					</div>
				}

				@if (errorGeneric || noWebexRecordingsFound) {
					<div class="system-msg error-msg">
						<span class="glyphicons remove_2"></span>{{ 'Uploads_Import_WebEx_NoRecordings' | translate }}
					</div>
				}
			}

			<vb-ui-data-grid [hidden]="showWebexSiteSelection" [ngClass]="styles.grid" [themed]="true" [columnDefs]="gridColumnDefs" [defaultColDef]="gridDefaultColDef" [gridOptions]="gridOptions" [rowData]="webexRecordings" [rowMultiSelectWithClick]="true" [rowSelection]="'multiple'" (gridReady)="onGridReady($event)">
			</vb-ui-data-grid>

		</div>
	</div>

	<div class="modal-footer" [ngClass]="styles.dialogFooterWrapper">
		<div [ngClass]="styles.dialogFooter">
			@if (showWebexSiteSelection) {
				<button type="button" class="margin-right-5" (click)="closeDialog()" vbBtnSecondary>
					{{ 'Cancel' | translate }}
				</button>
				<button type="button" vbBtnPrimary (click)="onNextClick()" [disabled]="webexImportForm.invalid">
					{{ 'Next' | translate }}
				</button>
			} @else {
				@if (webexSitesSettings.length > 1) {
					<button type="button" class="margin-right-5" (click)="onBackToWebexSitesList()" vbBtnSecondary>
						{{ 'Back' | translate }}
					</button>
				}
				<button type="button" class="margin-right-5" (click)="closeDialog()" vbBtnSecondary>
					{{ 'Cancel' | translate }}
				</button>
				<button type="submit" vbBtnPrimary [disabled]="webexImportForm.invalid">
					{{ 'Import' | translate }}
				</button>
			}
		</div>
	</div>

</form>

